import type { Key } from './en.js';

export const uk: Record<Key, string> = {
  'app.title': 'Tellvo.app — налаштування телефона',
  'brand.name': 'Tellvo.app',
  'theme.label': 'Тема сторінки',
  'theme.system': 'Як у системі',
  'theme.light': 'Світла',
  'theme.dark': 'Темна',

  'connect.connecting': 'Підключаємося до сервісу налаштування…',
  'connect.waitingPhone': 'Чекаємо дані з iPhone…',

  'pair.title': 'Підключіть iPhone',
  'pair.lead': 'Налаштовуйте лінії на великому екрані. Усе, що ви вводите, одразу з’являється на iPhone.',
  'pair.qr': 'Наведіть камеру iPhone',
  'pair.qrLabel': 'QR-код для камери iPhone',
  'pair.codeLabel': 'Код сполучення',
  'pair.privacy': 'Усе, що ви введете, шифрується між цим браузером і телефоном. Сервер Tellvo.app бачить лише шифр.',
  'pair.timer': 'Код діє ще {time}',
  'pair.or': 'або введіть код у Tellvo.app',
  'pair.expired.title': 'Код більше не діє',
  'pair.expired.text': 'Він діяв 2 хвилини. Отримайте новий і наведіть камеру ще раз.',
  'pair.renew': 'Новий код',
  'pair.lost.title': 'Зв’язок перервався',
  'pair.lost.text': 'Перепідключаємося. QR залишиться тим самим, код оновиться.',
  'pair.offline.title': 'Зв’язок не відновився',
  'pair.offline.text': 'Перевірте інтернет на комп’ютері й отримайте новий код.',
  'sync.reconnecting': 'Перепідключення…',
  'sync.offline': 'Немає зв’язку',
  'notice.reconnecting': 'Зв’язок зі службою налаштування перервався, перепідключаємося. Можна продовжувати: зміни зачекають.',
  'notice.offline': 'Зв’язок не відновився. Зміни збережено на цій сторінці, вони підуть, коли він з’явиться.',
  'action.retry': 'Повторити',

  'confirm.title': 'Підключився iPhone. Дозволити?',
  'confirm.text': 'Дозволяйте, лише якщо ви самі ввели код на цьому телефоні.',
  'confirm.allow': 'Дозволити',
  'confirm.reject': 'Відхилити',

  'sync.online': 'На зв’язку',
  'sync.away': 'У фоні',
  'sync.device': '{device} · Tellvo.app {version}',
  'sync.pending': 'Не синхронізовано: {count}',

  'accounts.title': 'Лінії',
  'accounts.add': 'Додати лінію',
  'accounts.empty': 'Облікових записів поки немає. Потрібні сервер, логін і пароль від провайдера.',
  'accounts.addFirst': 'Додати лінію',
  'accounts.toggle': 'Лінія «{name}» активна',

  'state.working': 'Працює',
  'state.connecting': 'Підключення',
  'state.error': 'Помилка',
  'state.off': 'Вимкнено',
  'state.idle': 'Неактивний',
  'state.waiting': 'Чекає',

  'line.notOnPhone': 'Ще не на iPhone',
  'line.pendingAway': 'Застосується, коли iPhone повернеться',
  'line.pendingOnline': 'Надсилається на iPhone',
  'line.deleting': 'Видалиться після підтвердження на iPhone',
  'line.failed': 'Не застосовано',
  'line.off': 'Реєстрацію вимкнено',
  'line.error': 'Не реєструється',
  'line.pushMissing': 'Не дзвонить, коли закрито',

  'editor.new': 'Новий обліковий запис',
  'editor.back': 'До списку',
  'editor.pick': 'Виберіть обліковий запис ліворуч або додайте новий.',
  'editor.advanced': 'Додатково',
  'editor.passwordKeep': 'Збережено на iPhone. Залиште порожнім, щоб не змінювати.',
  'editor.failed': 'iPhone не застосував цей обліковий запис: {reason}',
  'editor.registrationFailed': '{reason} Перевірте сервер, логін і пароль або спробуйте інший транспорт.',
  'editor.switchFirst': 'Спершу збережіть або скасуйте зміни.',

  'push.off': 'Дзвінки при закритому застосунку вимкнено.',
  'push.transport': 'При закритому застосунку дзвінок не дійде: сервіс push поки працює через UDP і TCP, а в цього облікового запису {transport}.',
  'push.afterSave': 'Надішлеться на сервіс push після збереження.',
  'push.noPassword': 'При закритому застосунку дзвінок не дійде: на iPhone немає пароля цього облікового запису.',
  'push.noToken': 'iPhone ще не видав токен для push. Відкрийте Tellvo.app на телефоні.',
  'push.refused': 'Сервіс push не прийняв обліковий запис ({status}). При закритому застосунку дзвінок не дійде.',
  'push.unreachable': 'Сервіс push не відповів. Tellvo.app повторить при наступній зміні.',
  'push.useUdp': 'Вибрати UDP',
  'accounts.active': 'Активна',
  'accounts.pushToggle': 'Дзвінки при закритому застосунку: {name}',
  'line.pushNoRoom': 'Немає місця для push: {used} з {limit}',
  'line.pushNoRoomBare': 'Немає місця для push',
  'fact.dnd': 'Не турбувати на iPhone',
  'push.noRoom': 'Немає місця в тарифі: push увімкнено для {used} з {limit}.',
  'push.noRoomBare': 'Немає місця в тарифі: push уже ввімкнено для всіх ліній, які він дозволяє.',
  'push.otherDevices': 'Усі місця тарифу зайняті іншими пристроями.',
  'push.offAll': 'Вимкнено для всіх ліній на iPhone.',
  'push.enable': 'Увімкнути',

  'field.displayName': 'Назва',
  'field.displayName.hint': 'Видно у виборі облікового запису на телефоні.',
  'field.domain': 'Сервер',
  'field.domain.hint': 'З даних провайдера, наприклад sip.example.com.',
  'field.username': 'Логін',
  'field.username.hint': 'Зазвичай номер або логін у провайдера.',
  'field.password': 'Пароль',
  'field.password.hint': 'Зберігається лише на iPhone.',
  'field.authUsername': 'Логін авторизації',
  'field.authUsername.hint': 'Лише якщо провайдер дав окремий.',
  'field.registrar': 'Реєстратор',
  'field.registrar.hint': 'Лише якщо провайдер його вказав.',
  'field.outboundProxy': 'Проксі',
  'field.outboundProxy.hint': 'Лише якщо провайдер його вказав.',
  'field.transport': 'Транспорт',
  'field.transport.hint': 'Як телефон зв’язується із сервером.',
  'field.port': 'Порт',
  'field.port.hint': 'Порожньо — стандартний порт для транспорту.',
  'field.srtp': 'Шифрування дзвінка',
  'field.srtp.hint': 'Чи шифрується звук розмови.',
  'field.registerIntervalSeconds': 'Перереєстрація',
  'field.registerIntervalSeconds.hint': 'У секундах. Порожньо — 600.',
  'field.stunServer': 'STUN-сервер',
  'field.stunServer.hint': 'Допомагає за деякими роутерами. Порожньо — без нього.',
  'field.trustedCertificateSha256': 'Довірений сертифікат',
  'field.trustedCertificateSha256.hint': 'Лише для TLS: відбиток SHA-256 сертифіката вашої АТС, якщо телефон не довіряє йому сам (самопідписаний). Порожньо — вирішує система.',
  'field.trustedCertificateSha256.invalid': 'Введіть 64 шістнадцяткові цифри; двокрапки й пробіли можна.',
  'field.codecs': 'Кодеки',
  'field.codecs.hint': 'Телефон пропонує їх у цьому порядку.',

  'srtp.disabled': 'Вимкнено',
  'srtp.disabled.note': 'Звук іде без шифрування. Працює з будь-яким сервером.',
  'srtp.optional': 'Якщо доступно',
  'srtp.optional.note': 'Шифрує, коли сервер уміє, інакше без шифрування.',
  'srtp.mandatory': 'Обов’язково',
  'srtp.mandatory.note': 'Без шифрування дзвінок не почнеться.',

  'foot.missing': 'Бракує: {fields}',
  'foot.away': 'Перевірка працює, коли iPhone на зв’язку.',
  'foot.password': 'Новий пароль підтверджується на iPhone.',

  'action.check': 'Перевірити',
  'action.checking': 'Перевіряємо…',
  'action.save': 'Зберегти',
  'action.delete': 'Видалити',
  'action.cancel': 'Скасувати',
  'action.startOver': 'Почати знову',
  'action.copy': 'Скопіювати',
  'action.showLog': 'Показати журнал',

  'check.title': 'Перевірка',
  'check.registered': 'Обліковий запис реєструється.',
  'check.failed': 'Не реєструється: {reason}',

  'notice.saved': 'Збережено на iPhone.',
  'notice.savedHere': 'Збережено тут. Застосується, коли iPhone повернеться.',
  'notice.deleted': 'Обліковий запис видалено.',
  'notice.rejected': 'Відхилено на iPhone.',
  'notice.plansOpen': 'Тарифи відкрито на iPhone.',
  'notice.plansClosed': 'iPhone не зміг показати тарифи. Відкрийте на ньому Tellvo.app і спробуйте ще раз.',
  'notice.confirmDelete': 'Підтвердіть видалення на iPhone.',
  'notice.confirmPassword': 'Підтвердіть новий пароль на iPhone.',
  'notice.deleteLater': 'Видалення застосується, коли iPhone повернеться. Підтвердити його потрібно на телефоні.',

  'app.section': 'На iPhone',
  'app.appearance': 'Оформлення застосунку на iPhone',
  'app.appearance.hint': 'Лише застосунок на телефоні. У цієї сторінки свій перемикач угорі.',
  'app.appearance.system': 'Як в iOS',
  'app.appearance.light': 'Світле',
  'app.appearance.dark': 'Темне',

  'features.section': 'Функції',
  'features.pushIncoming': 'Дзвінки при закритому застосунку',
  'features.pushIncoming.hint': 'Дзвінок дійде, навіть якщо Tellvo.app не запущено.',
  'features.pushIncoming.unavailable': 'З’явиться з підпискою Tellvo.app.',
  'features.sms': 'SMS через провайдера',
  'features.sms.hint': 'Надсилання та отримання SMS у провайдерів, які це підтримують.',
  'features.sms.unavailable': 'У розробці.',
  'features.soon': 'Згодом',
  'features.toggle': 'Увімкнути «{name}»',

  'diag.section': 'Діагностика',
  'diag.log': 'Журнал SIP',
  'diag.log.hint': 'Усе, чим iPhone обмінювався із серверами. Знадобиться підтримці провайдера.',
  'diag.empty': 'Журнал порожній.',

  'lost.text': 'Перевірте інтернет на цьому комп’ютері. Якщо почати знову, iPhone треба буде підключити ще раз, а зміни, яких він ще не отримав, зникнуть.',

  'error.rejected': 'Ви відхилили підключення. Почніть знову, щоб підключитися ще раз.',
  'error.decrypt': 'Не вдалося прочитати повідомлення телефона. Почніть знову, щоб підключитися ще раз.',
  'error.bye': 'Телефон завершив сесію.',
  'error.expired': 'Код і QR-код застаріли.',
  'error.roomFull': 'До цієї сторінки вже підключено інший браузер.',
  'error.tooMany': 'Забагато неправильних кодів.',
  'error.relay': 'Сервіс налаштування відхилив підключення ({code}).',
  'field.invalidNumber': 'Введіть ціле число від {min} до {max}.',
  'landing.text': 'Це посилання відкриває Tellvo.app на iPhone. Відскануйте QR-код камерою телефона.',

  // Redesign C (tellvo-voip-client#96)
  'brand.page': 'Налаштування телефона',
  'pair.step1': 'Відкрийте Tellvo.app на iPhone',
  'pair.step2': 'Перейдіть у {path}',
  'pair.step2.path': 'Налаштування › Керування з комп’ютера',
  'pair.step3': 'Відскануйте код камерою',
  'pair.step3.hint': 'Або введіть 6 цифр у Tellvo.app. Підійде будь-який спосіб.',
  'pair.get': 'Ще немає Tellvo.app?',
  'pair.appStore': 'Завантажте в App Store',
  'console.summary.empty': 'Налаштуймо першу лінію',
  'console.summary.all': 'Усі лінії готові до дзвінків',
  'console.summary.some': 'Готові лінії: {ready} з {total}',
  'console.summary.attention': 'Готові лінії: {ready} з {total}. «{name}» потребує уваги.',
  'console.sub.empty': 'Введіть тут дані провайдера. Вони з’являються на iPhone під час набору, а iPhone сам їх перевірить.',
  'console.sub.ok': 'Зміни звідси з’являються на iPhone під час набору.',
  'console.sub.attention': 'Сервер не прийняв вхід. Відкрийте лінію й виправте; iPhone спробує знову одразу після збереження.',
  'console.fix': 'Виправити «{name}»',
  'console.stat.ready': 'Готові',
  'console.stat.attention': 'Потребують уваги',
  'console.stat.quiet': 'Мовчать при закритому',
  'link.browser': 'Цей браузер',
  'link.encrypted': 'Наскрізне шифрування',
  'link.live': 'На зв’язку. Правки видно на iPhone одразу.',
  'link.away': 'iPhone у фоні. Зміни підуть, коли Tellvo.app знову відкриють.',
  'link.waiting': 'Чекають на iPhone: {count}. Підуть, коли Tellvo.app знову відкриють.',
  'link.reconnecting': 'Зв’язок зі службою налаштування перервався. Перепідключаємось; правки чекають тут.',
  'link.offline': 'Зв’язок не повернувся. Правки залишаться тут, доки він не з’явиться.',
  'accounts.lead': 'Кожна лінія — це SIP-обліковий запис. Вимкніть лінію, щоб вона не дзвонила, не видаляючи її.',
  'accounts.addHint': 'Сервер, логін і пароль від провайдера',
  'accounts.fix': 'Виправити вхід',
  'accounts.edit': 'Змінити «{name}»',
  'accounts.drag': 'Перетягніть, щоб змінити порядок набору',
  'accounts.moveHint': 'Облікові записи набирають у цьому порядку. Перетягніть картку, щоб переставити її; з клавіатури картку у фокусі переставляють Alt і стрілки.',
  'accounts.moved': 'Переміщено на позицію {n} з {total}',
  'fact.off': 'Вимкнена, дзвінків немає',
  'fact.open': 'Дзвонить, коли застосунок відкритий',
  'fact.closed': 'Дзвонить навіть при закритому застосунку',
  'fact.enc.off': 'Дзвінки без шифрування',
  'fact.enc.optional': 'Дзвінки шифруються',
  'fact.enc.mandatory': 'Лише шифровані дзвінки',
  'line.ext': 'Дод. {n}',
  'start.1.title': 'Додайте лінію',
  'start.1.text': 'Сервер, логін і пароль. Провайдер надсилає їх під час підключення.',
  'start.2.title': 'Перевірте',
  'start.2.text': 'iPhone увійде на сервер і покаже результат тут.',
  'start.3.title': 'Приймайте дзвінки',
  'start.3.text': 'Дзвінки надходять на iPhone як звичайні, навіть на заблокований екран.',
  'plan.trial': 'Перший місяць безкоштовно',
  'plan.title': 'Хай додзвонюються, навіть коли Tellvo.app закритий',
  'plan.lead': '{lines} дзвонять, лише поки застосунок відкритий. З підпискою iPhone дзвонить на екрані блокування, як звичайний телефон, а застосунок лишається закритим, доки ви не відповісте.',
  'plan.lead.yourLines': 'Ваші лінії',
  'plan.billing': 'Період оплати',
  'plan.monthly': 'Щомісяця',
  'plan.yearly': 'На рік',
  'plan.save.months': '2 місяці безкоштовно',
  'plan.save.percent': 'Вигода {n}%',
  'plan.source': 'Ціни з {device} · App Store, {region}',
  'plan.pick': 'Тариф',
  'plan.personal': 'Особистий',
  'plan.personal.limits': '3 облікові записи, 2 пристрої',
  'plan.family': 'Сімейний',
  'plan.family.limits': 'До 6 людей, кожному 3 облікові записи і 2 пристрої',
  'plan.pro': 'Про',
  'plan.pro.limits': '10 облікових записів, 5 пристроїв',
  'plan.fits': 'Вистачить на ваші облікові записи',
  'plan.perMonth': '/ місяць',
  'plan.perYear': '/ рік',
  'plan.try': 'Спробувати «{plan}» місяць безкоштовно',
  'plan.subscribe': 'Оформити «{plan}»',
  'plan.ctaHint': 'Відкриє тарифи на {device}. Підтверджуєте через Face ID; скасувати можна будь-коли в App Store.',
  'plan.away': 'Відкрийте Tellvo.app на iPhone, щоб побачити ціни й почати безкоштовний місяць.',
  'plan.how': 'Підписка оформлюється в Tellvo.app на iPhone:',
  'plan.currency': 'Ціни у валюті вашого App Store.',
  'plan.path': 'Налаштування › Дзвінки при закритому застосунку',
  'plan.shot.alt': 'Вхідний дзвінок на екрані блокування, поки Tellvo.app закритий',
  'plan.shot.caption': 'Застосунок закритий. Дзвінок однаково надходить.',
  'plan.shot.line': 'Основна · Tellvo.app',
  'plan.shot.incoming': 'вхідний виклик',
  'editor.group.signin': 'Вхід',
  'editor.group.security': 'Шифрування і звук',
  'editor.group.connection': 'Детальніше про з’єднання',
  'editor.group.connection.hint': 'Зазвичай не потрібно',
  'editor.close': 'Закрити',
  'editor.new.sub': 'Налаштування з’являються на iPhone під час набору',
  'check.showLog': 'Показати SIP-повідомлення',
  'features.paid': 'За підпискою',
};
